import { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faBars, faGaugeHigh } from '@fortawesome/free-solid-svg-icons';

import '../styles/Sidenav.css';

const Sidenav = ({ Dashboard }) =>
{
    const [sidebar, setSidebar] = useState();

    const handleSidebar = () =>
    {
        sidebar && document.body.classList.toggle('sb-sidenav-toggled');
        sidebar && localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sb-sidenav-toggled'));
    }

    useEffect(() =>
    {
        const sidebarToggle = document.querySelector('#sidebarToggle');

        setSidebar(sidebarToggle);
    }, []);

    return (
        <div className="sb-nav-fixed">
            <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
                <Link className="navbar-brand ps-3" to="/">{'Datos Pesqueros'}</Link>
                <button className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 d-none" id="sidebarToggle" onClick={handleSidebar}><FontAwesomeIcon icon={faBars} /></button>
            </nav>
            <div style={{ paddingTop: '3rem' }}>
            {/* <div id="layoutSidenav"> */}
                {/* <div id="layoutSidenav_nav">
                    <nav className="sb-sidenav accordion sb-sidenav-light" id="sidenavAccordion">
                        <div className="sb-sidenav-menu">
                            <div className="nav">
                                <div className="sb-sidenav-menu-heading">Core</div>
                                <Link className="nav-link" to="/dashboard">
                                    <div className="sb-nav-link-icon"><FontAwesomeIcon icon={faGaugeHigh} /></div>
                                    {'Dashboard'}
                                </Link>
                            </div>
                        </div>
                    </nav>
                </div> */}
                <div id="layoutSidenav_content">
                    <main>

                        { Dashboard && <Dashboard /> }

                    </main>
                    <footer className="py-4 bg-light mt-auto">
                        <div className="container-fluid px-4">
                            <div className="d-flex align-items-center justify-content-between small">
                                <div className="text-muted">{'Edificio central IFOP: Almirante Blanco Encalada 839, Valparaíso. Chile.'}</div>
                            </div>
                        </div>
                    </footer>
                </div>
            </div>
        </div>
    );
}

export default Sidenav;
